import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MinimalLayout from 'layout/MinimalLayout';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// login option 3 routing
const AuthLogin = Loadable(lazy(() => import('views/auth/Login')));
const AuthRegister = Loadable(lazy(() => import('views/auth/Register')));

// profile routing
const ProfilePage = Loadable(lazy(() => import('views/profile')));
const ProfileEditPage = Loadable(lazy(() => import('views/profile/edit')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/dashboard')));

// Haunted House Halloween
const HauntedHouseAdminPage = Loadable(lazy(() => import('views/haunted')));

const AchivePage = Loadable(lazy(() => import('views/archive')));

const OnProgres = Loadable(lazy(() => import('views/error/OnProgres')));

const RolePage = Loadable(lazy(() => import('views/role')));
const PermissionPage = Loadable(lazy(() => import('views/role/permission')));
const UserPage = Loadable(lazy(() => import('views/user')));
const UserAddPage = Loadable(lazy(() => import('views/user/add')));
const UserDatailPage = Loadable(lazy(() => import('views/user/detail')));
const UserEditPage = Loadable(lazy(() => import('views/user/edit')));

const CabangPage = Loadable(lazy(() => import('views/cabang')));

const PaymentPage = Loadable(lazy(() => import('views/pembayaran')));
const AddPaymentPage = Loadable(lazy(() => import('views/pembayaran/add')));
const PaymentDetailPage = Loadable(lazy(() => import('views/pembayaran/detail')));

// Verifikasi Pembayaran
const VerifikasiPembayaranPage = Loadable(lazy(() => import('views/verifikasipembayaran')));
const VerifikasiPembayaranDetailPage = Loadable(lazy(() => import('views/verifikasipembayaran/detail')));

const SekolahPage = Loadable(lazy(() => import('views/sekolah')));

const UserStudentCodePage = Loadable(lazy(() => import('views/accesscode')));

const TahunAjaranPage = Loadable(lazy(() => import('views/tahunajaran')));

const JenjangPage = Loadable(lazy(() => import('views/jenjang')));

const ExamTypePage = Loadable(lazy(() => import('views/examtype')));
const ExamSchedulePage = Loadable(lazy(() => import('views/examschedule')));
const ExamScorePage = Loadable(lazy(() => import('views/examscore')));

const MapelPage = Loadable(lazy(() => import('views/mapel')));
const MapelBabPage = Loadable(lazy(() => import('views/mapelbab')));

const VideoPage = Loadable(lazy(() => import('views/video')));
const VideoHistoryPage = Loadable(lazy(() => import('views/video/history')));
const VideoDetailPage = Loadable(lazy(() => import('views/video/detail')));
const VideoAddPage = Loadable(lazy(() => import('views/video/add')));
const VideoEditPage = Loadable(lazy(() => import('views/video/edit')));
const VideoQuestionForm = Loadable(lazy(() => import('views/video/question/form')));

const SWMPage = Loadable(lazy(() => import('views/studywithme')));
const SWMDetailPage = Loadable(lazy(() => import('views/studywithme/detail')));
const SWMAddPage = Loadable(lazy(() => import('views/studywithme/add')));
const SWMEditPage = Loadable(lazy(() => import('views/studywithme/edit')));
const SWMHistoryPage = Loadable(lazy(() => import('views/studywithme/history')));
const SWMSessionPage = Loadable(lazy(() => import('views/studywithme/session')));
const SWMPreviewPage = Loadable(lazy(() => import('views/studywithme/preview')));
const SWMQuestionPage = Loadable(lazy(() => import('views/studywithme/soal')));
const SWMQuestionAddPage = Loadable(lazy(() => import('views/studywithme/soal/add')));
const SWMQuestionEditPage = Loadable(lazy(() => import('views/studywithme/soal/edit')));

const MateriPage = Loadable(lazy(() => import('views/materi')));
const MateriAddPage = Loadable(lazy(() => import('views/materi/add')));
const MateriEditPage = Loadable(lazy(() => import('views/materi/edit')));

const MatchWordPage = Loadable(lazy(() => import('views/matchword')));
const MatchWordAddPage = Loadable(lazy(() => import('views/matchword/add')));
const MatchWordEditPage = Loadable(lazy(() => import('views/matchword/edit')));
const MatchWordHistoryPage = Loadable(lazy(() => import('views/matchword/history')));
const MatchWordSessionPage = Loadable(lazy(() => import('views/matchword/session')));

const FilePage = Loadable(lazy(() => import('views/file')));
const FileAddPage = Loadable(lazy(() => import('views/file/add')));
const FileEditPage = Loadable(lazy(() => import('views/file/edit')));

const HargaPage = Loadable(lazy(() => import('views/harga')));
const HargaAddPage = Loadable(lazy(() => import('views/harga/add')));
const HargaEditPage = Loadable(lazy(() => import('views/harga/edit')));

const LatihanPage = Loadable(lazy(() => import('views/latihan')));
const LatihanAddPage = Loadable(lazy(() => import('views/latihan/add')));
const LatihanEditPage = Loadable(lazy(() => import('views/latihan/edit')));

const HistoryPage = Loadable(lazy(() => import('views/latihan/history')));

const SoalPage = Loadable(lazy(() => import('views/soal')));
const SoalAddPage = Loadable(lazy(() => import('views/soal/add')));
const SoalEditPage = Loadable(lazy(() => import('views/soal/edit')));
const SessionPage = Loadable(lazy(() => import('views/soal/session')));
const PreviewSoalPage = Loadable(lazy(() => import('views/soal/preview')));
const PreviewRangkataPage = Loadable(lazy(() => import('views/soal/session/rangkata')));

const ExamArchPage = Loadable(lazy(() => import('views/examarch')));
const ExamArchAddPage = Loadable(lazy(() => import('views/examarch/add')));
const ExamArchEditPage = Loadable(lazy(() => import('views/examarch/edit')));
const ExamArchHistoryPage = Loadable(lazy(() => import('views/examarch/history')));
const ExamArchQuestPage = Loadable(lazy(() => import('views/examarch/question')));
const ExamArchQuestAddPage = Loadable(lazy(() => import('views/examarch/question/add')));
const ExamArchQuestEditPage = Loadable(lazy(() => import('views/examarch/question/edit')));
const ExamArchSessionPage = Loadable(lazy(() => import('views/examarch/question/session')));
const ExamArchQuestPreviewPage = Loadable(lazy(() => import('views/examarch/question/preview')));

const StudentPage = Loadable(lazy(() => import('views/student')));
const StudentCodePage = Loadable(lazy(() => import('views/student/code')));
const CodeHistoryPage = Loadable(lazy(() => import('views/student/CodeHistory')));
const StudentAddPage = Loadable(lazy(() => import('views/student/add')));
const StudentDatailPage = Loadable(lazy(() => import('views/student/detail')));
const StudentEditPage = Loadable(lazy(() => import('views/student/edit')));
const StudentBirtdayPage = Loadable(lazy(() => import('views/student/birthday')));

// Student Accounting Pages (khusus akuntan)
const StudentAccountingActivePage = Loadable(lazy(() => import('views/studentaccounting/active/activeindex')));
const StudentAccountingActiveDetailPage = Loadable(lazy(() => import('views/studentaccounting/active/detail')));
const StudentAccountingNewmonthPage = Loadable(lazy(() => import('views/studentaccounting/newmonth/newmonthindex')));
const StudentAccountingNewmonthDetailPage = Loadable(lazy(() => import('views/studentaccounting/newmonth/detail')));
const StudentAccountingPendingPage = Loadable(lazy(() => import('views/studentaccounting/pending/pendingindex')));
const StudentAccountingPendingDetailPage = Loadable(lazy(() => import('views/studentaccounting/pending/detail')));

// Operasional Pages
const SaldoOperasionalPage = Loadable(lazy(() => import('views/saldooperasional')));
const SaldoOperasionalAddPage = Loadable(lazy(() => import('views/saldooperasional/add')));
const SaldoOperasionalDetailPage = Loadable(lazy(() => import('views/saldooperasional/detail')));
const SaldoOperasionalEditPage = Loadable(lazy(() => import('views/saldooperasional/edit')));
const PengeluaranOperasionalPage = Loadable(lazy(() => import('views/pengeluaranoperasional')));
const PengeluaranOperasionalAddPage = Loadable(lazy(() => import('views/pengeluaranoperasional/add')));
const PengeluaranOperasionalDetailPage = Loadable(lazy(() => import('views/pengeluaranoperasional/detail')));
const PengeluaranOperasionalEditPage = Loadable(lazy(() => import('views/pengeluaranoperasional/edit')));
const DetailTopupPage = Loadable(lazy(() => import('views/pengeluaranoperasional/detailtopup')));
const DetailTopupItemPage = Loadable(lazy(() => import('views/pengeluaranoperasional/detailtopupitem')));
const LaporanOperasionalPage = Loadable(lazy(() => import('views/laporanoperasional')));
const LaporanOperasionalDetailPage = Loadable(lazy(() => import('views/laporanoperasional/detail')));
const InputPengeluaranPage = Loadable(lazy(() => import('views/inputpengeluaran')));
const InputPengeluaranAddPage = Loadable(lazy(() => import('views/inputpengeluaran/add')));
const InputPengeluaranDetailPage = Loadable(lazy(() => import('views/inputpengeluaran/detail')));
const InputPengeluaranEditPage = Loadable(lazy(() => import('views/inputpengeluaran/edit')));

const ParentPage = Loadable(lazy(() => import('views/parent')));
const ParentAddPage = Loadable(lazy(() => import('views/parent/add')));
const ParentDatailPage = Loadable(lazy(() => import('views/parent/detail')));
const ParentEditPage = Loadable(lazy(() => import('views/parent/edit')));

const SchedulePage = Loadable(lazy(() => import('views/schedule')));
const AddSchedulePage = Loadable(lazy(() => import('views/schedule/add')));
const EditSchedulePage = Loadable(lazy(() => import('views/schedule/edit')));
const DetailSchedulePage = Loadable(lazy(() => import('views/schedule/detail')));

const LearningHistoryPage = Loadable(lazy(() => import('views/studyhistory')));

// subsicription type page
const SubscriptionTypePage = Loadable(lazy(() => import('views/subscriptiontype')));

// School Type page
const SchoolTypePage = Loadable(lazy(() => import('views/schooltype')));

// Class Type page
const ClassTypePage = Loadable(lazy(() => import('views/classtype')));

// class Schedule page
const ClassSchedulePage = Loadable(lazy(() => import('views/classSchedule')));
const AddClassSchedulePage = Loadable(lazy(() => import('views/classSchedule/add')));
const EditClassSchedulePage = Loadable(lazy(() => import('views/classSchedule/edit')));

// Program Change Pages
const ProgramChangeIndexPage = Loadable(lazy(() => import('views/programChange')));
const ProgramChangeDetailPage = Loadable(lazy(() => import('views/programChange/detail')));
const ProgramChangeApprovedPage = Loadable(lazy(() => import('views/programChange/approved')));
const ProgramChangeApprovedDetailPage = Loadable(lazy(() => import('views/programChange/detailApproved')));
const ProgramChangeHistoryPage = Loadable(lazy(() => import('views/programChange/history')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  // return useRoutes([MainRoutes, AuthenticationRoutes]);
  return (
    <Routes>
      <Route element={<MinimalLayout />}>
        {/* <Route path="/" element={<HomePage />} /> */}
        <Route path="/login" element={<AuthLogin />} />
        <Route path="/register" element={<AuthRegister />} />
      </Route>

      <Route element={<MainLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="comingsoon" element={<OnProgres />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="haunted-house" element={<HauntedHouseAdminPage />} />

        <Route path="archive" element={<AchivePage />} />

        <Route path="schedule" element={<SchedulePage />} />
        <Route path="schedule/add" element={<AddSchedulePage />} />
        <Route path="schedule/edit/:id" element={<EditSchedulePage />} />
        <Route path="schedule/detail/:id" element={<DetailSchedulePage />} />

        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile/edit" element={<ProfileEditPage />} />

        <Route path="student/code" element={<StudentCodePage />} />
        <Route path="student/code/:id" element={<CodeHistoryPage />} />
        <Route path="student/tambah" element={<StudentAddPage />} />
        <Route path="student/detail/:id" element={<StudentDatailPage />} />
        <Route path="student/edit/:id" element={<StudentEditPage />} />
        <Route path="student/:status" element={<StudentPage />} />
        <Route path="student-birthday" element={<StudentBirtdayPage />} />

        {/* Student Accounting Routes (khusus akuntan) */}
        <Route path="/student-accounting">
          <Route path="active" element={<StudentAccountingActivePage />} />
          <Route path="active/:id" element={<StudentAccountingActiveDetailPage />} />
          <Route path="newmonth" element={<StudentAccountingNewmonthPage />} />
          <Route path="newmonth/:id" element={<StudentAccountingNewmonthDetailPage />} />
          <Route path="pending" element={<StudentAccountingPendingPage />} />
          <Route path="pending/:id" element={<StudentAccountingPendingDetailPage />} />
        </Route>

        {/* Operasional Routes */}
        <Route path="/operasional">
          <Route path="saldo" element={<SaldoOperasionalPage />} />
          <Route path="saldo/tambah" element={<SaldoOperasionalAddPage />} />
          <Route path="saldo/:id" element={<SaldoOperasionalDetailPage />} />
          <Route path="saldo/:id/edit" element={<SaldoOperasionalEditPage />} />
          <Route path="pengeluaran" element={<PengeluaranOperasionalPage />} />
          <Route path="pengeluaran/tambah" element={<PengeluaranOperasionalAddPage />} />
          <Route path="pengeluaran/topup/:cabangId" element={<DetailTopupPage />} />
          <Route path="pengeluaran/topup-item/:id" element={<DetailTopupItemPage />} />
          <Route path="pengeluaran/:id" element={<PengeluaranOperasionalDetailPage />} />
          <Route path="pengeluaran/:id/edit" element={<PengeluaranOperasionalEditPage />} />
          <Route path="laporan" element={<LaporanOperasionalPage />} />
          <Route path="laporan/detail" element={<LaporanOperasionalDetailPage />} />
          <Route path="input-pengeluaran" element={<InputPengeluaranPage />} />
          <Route path="input-pengeluaran/tambah" element={<InputPengeluaranAddPage />} />
          <Route path="input-pengeluaran/:id" element={<InputPengeluaranDetailPage />} />
          <Route path="input-pengeluaran/:id/edit" element={<InputPengeluaranEditPage />} />
        </Route>

        <Route path="parent/:status" element={<ParentPage />} />
        <Route path="parent/tambah" element={<ParentAddPage />} />
        <Route path="parent/detail/:id" element={<ParentDatailPage />} />
        <Route path="parent/edit/:id" element={<ParentEditPage />} />

        <Route path="payment" element={<PaymentPage />} />
        <Route path="payment/create" element={<AddPaymentPage />} />
        <Route path="payment/:id" element={<PaymentDetailPage />} />

        <Route path="verifikasi-pembayaran" element={<VerifikasiPembayaranPage />} />
        <Route path="verifikasi-pembayaran/:id" element={<VerifikasiPembayaranDetailPage />} />

        <Route path="users/:status" element={<UserPage />} />
        <Route path="users/tambah" element={<UserAddPage />} />
        <Route path="users/detail/:id" element={<UserDatailPage />} />
        <Route path="users/edit/:id" element={<UserEditPage />} />

        <Route path="/settings">
          <Route path="accesscode" element={<UserStudentCodePage />} />
          <Route path="roles" element={<RolePage />} />
          <Route path="roles/:roleID/permission" element={<PermissionPage />} />
        </Route>

        <Route path="/learning">
          <Route path="history" element={<LearningHistoryPage />} />

          <Route path="latihan/tambah/:type" element={<LatihanAddPage />} />
          <Route path="latihan/:type" element={<LatihanPage />} />
          <Route path="latihan/:id/edit" element={<LatihanEditPage />} />
          <Route path="latihan/:latihanID/history" element={<HistoryPage />} />
          <Route path="latihan/:latihanID/preview" element={<PreviewSoalPage />} />
          <Route path="latihan/:latihanID/preview/rangkata" element={<PreviewRangkataPage />} />
          <Route path="latihan/:latihanID/soal" element={<SoalPage />} />
          <Route path="latihan/:latihanID/soal/tambah" element={<SoalAddPage />} />
          <Route path="latihan/:latihanID/soal/:id/edit" element={<SoalEditPage />} />
          <Route path="latihan/:latihanID/:sessionID" element={<SessionPage />} />

          <Route path="video" element={<VideoPage />} />
          <Route path="video/tambah" element={<VideoAddPage />} />
          <Route path="video/:id" element={<VideoDetailPage />} />
          <Route path="video/:id/edit" element={<VideoEditPage />} />
          <Route path="video/:id/history" element={<VideoHistoryPage />} />
          <Route path="video/:id/question/add" element={<VideoQuestionForm />} />
          <Route path="video/:id/question/:questionId/edit" element={<VideoQuestionForm />} />

          <Route path="studywithme" element={<SWMPage />} />
          <Route path="studywithme/tambah" element={<SWMAddPage />} />
          <Route path="studywithme/:id" element={<SWMDetailPage />} />
          <Route path="studywithme/:id/edit" element={<SWMEditPage />} />
          <Route path="studywithme/:id/history" element={<SWMHistoryPage />} />
          <Route path="studywithme/:id/history/:sessionID" element={<SWMSessionPage />} />
          <Route path="studywithme/:id/preview/:stageIdx/:itemIdx" element={<SWMPreviewPage />} />
          <Route path="studywithme/:id/stage/:stageId/item/:itemId/question" element={<SWMQuestionPage />} />
          <Route path="studywithme/:id/stage/:stageId/item/:itemId/question/add" element={<SWMQuestionAddPage />} />
          <Route path="studywithme/:id/stage/:stageId/item/:itemId/question/:soalId/edit" element={<SWMQuestionEditPage />} />

          <Route path="materi" element={<MateriPage />} />
          <Route path="materi/tambah" element={<MateriAddPage />} />
          <Route path="materi/:id/edit" element={<MateriEditPage />} />

          <Route path="matchword" element={<MatchWordPage />} />
          <Route path="matchword/tambah" element={<MatchWordAddPage />} />
          <Route path="matchword/:id/edit" element={<MatchWordEditPage />} />
          <Route path="matchword/:id/history" element={<MatchWordHistoryPage />} />
          <Route path="matchword/:id/:sessionID" element={<MatchWordSessionPage />} />

          <Route path="file" element={<FilePage />} />
          <Route path="file/tambah" element={<FileAddPage />} />
          <Route path="file/:id/edit" element={<FileEditPage />} />

          <Route path="examarch" element={<ExamArchPage />} />
          <Route path="examarch/add" element={<ExamArchAddPage />} />
          <Route path="examarch/:id/edit" element={<ExamArchEditPage />} />
          <Route path="examarch/:id/history" element={<ExamArchHistoryPage />} />
          <Route path="examarch/:id/history/:sessionId" element={<ExamArchSessionPage />} />
          <Route path="examarch/:id/preview" element={<ExamArchQuestPreviewPage />} />
          <Route path="examarch/:id/question" element={<ExamArchQuestPage />} />
          <Route path="examarch/:id/question/add" element={<ExamArchQuestAddPage />} />
          <Route path="examarch/:id/question/:questionId/edit" element={<ExamArchQuestEditPage />} />
        </Route>

        <Route path="/exam">
          <Route path="schedule" element={<ExamSchedulePage />} />
          <Route path="scores" element={<ExamScorePage />} />
        </Route>
        <Route path="/data">
          <Route path="harga" element={<HargaPage />} />
          <Route path="harga/tambah" element={<HargaAddPage />} />
          <Route path="harga/:id/edit" element={<HargaEditPage />} />
          <Route path="sekolah" element={<SekolahPage />} />
          <Route path="cabang" element={<CabangPage />} />
          <Route path="tahunajaran" element={<TahunAjaranPage />} />
          <Route path="jenjang" element={<JenjangPage />} />
          <Route path="mapel" element={<MapelPage />} />
          <Route path="bab" element={<MapelBabPage />} />
          <Route path="examtype" element={<ExamTypePage />} />
          <Route path="subscriptiontype" element={<SubscriptionTypePage />} />
          <Route path="schooltype" element={<SchoolTypePage />} />
          <Route path="classtype" element={<ClassTypePage />} />
        </Route>

        <Route path="/classschedule">
          <Route path="/classschedule" element={<ClassSchedulePage />} />
          <Route path="/classschedule/Add" element={<AddClassSchedulePage />} />
          <Route path="/classschedule/Edit/:id" element={<EditClassSchedulePage />} />
        </Route>

        <Route path="/program-change">
          <Route path="approved" element={<ProgramChangeApprovedPage />} />
          <Route path="approved/:id" element={<ProgramChangeApprovedDetailPage />} />
          <Route path="history/:studentId" element={<ProgramChangeHistoryPage />} />
          <Route path="detail/:id" element={<ProgramChangeDetailPage />} />
          <Route path="" element={<ProgramChangeIndexPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}
